import { useNavigate } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function AccessDenied() {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col items-center justify-center py-24 text-center" data-testid="access-denied">
      <div className="h-16 w-16 rounded-2xl bg-[#FE3967]/10 flex items-center justify-center mb-5">
        <ShieldAlert className="h-8 w-8 text-[#FE3967]" />
      </div>
      <h1 className="font-display text-2xl font-bold text-[#1E2025]">403 — Access Denied</h1>
      <p className="mt-2 max-w-md text-sm text-slate-500">
        You're signed in, but your role doesn't have permission to view this page.
        Contact your administrator if you believe this is a mistake.
      </p>
      <Button className="mt-6" onClick={() => navigate("/")} data-testid="access-denied-home">
        Back to Dashboard
      </Button>
    </div>
  );
}
